import React, { PureComponent } from "react"

/* Constants */
import { utils, env } from "../../constants"


/* Component Stand */
class Stand extends PureComponent {

    render = () => {

        const { onClick } = this.props
        return (
            <div onClick={() => onClick()} className="game-button stand-button">
                <img src={`${env.endpoint}/images/buttons/stand.png`} alt="stand" />
                <p>{utils.translate("STAND")}</p>
            </div>
        )
    }

}

export default Stand